import { QueryClient } from '@tanstack/react-query';

// Enhanced React Query configuration for better performance
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Cache data for 2 minutes by default (less aggressive for external APIs)
      staleTime: 2 * 60 * 1000,
      // Keep inactive data for 10 minutes
      gcTime: 10 * 60 * 1000, 
      // Retry failed requests, but fewer times for external APIs
      retry: 1,
      // Don't refetch on window focus for external APIs
      refetchOnWindowFocus: false,
      // Refetch when network reconnects
      refetchOnReconnect: true,
      // Use mount refetch for fresh data
      refetchOnMount: true,
    },
    mutations: {
      // Retry failed mutations once
      retry: 1,
    },
  },
});

// Pre-configured query keys for consistency
export const QUERY_KEYS = {
  profile: (userId?: string) => ['profile', userId],
  posts: (filters?: any) => ['posts', filters],
  casts: (filters?: any) => ['casts', filters],
  communities: ['communities'],
  trends: (filters?: any) => ['trends', filters],
  usdaReports: ['usda-reports'],
  cropPlans: (userId?: string) => ['crop-plans', userId],
  prices: (location?: string) => ['prices', location],
} as const;
